import { uploadFile } from '../../../shared/api/uploadFile';

// Fase 5.15 -- `SubPanelTratos.jsx` (presentacional) llamaba `uploadFile` de `shared/api/*`
// directo. Se envuelve acá: `cliente_img` es un avatar público (URL estable), el resto es un
// documento de cliente privado con toggle de visibilidad propio.
export function uploadClientDoc(file, docType, onProgress) {
    const type = docType === 'cliente_img' ? 'client_avatar' : 'client_document';
    return uploadFile(file, type, { onProgress, returnFull: true });
}
